var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box",class:{
    dark: _vm.dark
  }},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"flex",class:{
        reverse: _vm.reverse
      }},[_c('div',{staticClass:"item"},[_c('div',[_vm._t("info")],2)]),_c('div',{staticClass:"item image-slot"},[_vm._t("image")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }